import MainLayout from "../../layouts/MainLayout";

import React from 'react';
import styled from 'styled-components';
import NewsItem from '../../components/NewsItem';
import { articles } from "@/helpers/api";
import { IArticle } from "@/components/forPages/forHome/NewsBlock";
import Pager, { PagerBox } from "../../components/Pager";
import { useRouter } from "next/router";

const countOnPage = 40;

export default function Articles({
  articles
}: {
  articles: IArticle[]
}){

  const router = useRouter();
  const currentPage = +router.query.page;
  const countOfPages = Math.ceil(700 / countOnPage);

  return <MainLayout>
      <Container>
        <div className="maxwidth">
        <Title>
          <span>Новости</span>&nbsp; и статьи
        </Title>
        <News>
          {articles.map(article => <NewsItem article={article} key={article.id} />)}
        </News>

        <PagerBox>
          <Pager url="/articles" current={currentPage} count={countOfPages} />
        </PagerBox>
        
      </div>
      </Container>
    </MainLayout>
}

export async function getServerSideProps(context) {
  const page = context.query.page;
  const articles_ = await articles(page * countOnPage, countOnPage);
  return { props: {
    articles: articles_
  }}
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 50px 0 70px;
`

const Title = styled.h2`
  font-size: var(--text-title);
  text-transform: uppercase;
  font-family: var(--font-semibold);
  text-align: center;
  color: var(--color-title);
  margin: 0 0 50px;

  & span {
    color: var(--green);
  }
`

const News = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 50px;

  @media (max-width: 600px) {
    grid-template-columns: 100%;
  }

  /* @media (max-width: 480px) {
    grid-template-columns: 100%;
  } */
`